module.exports = __webpack_public_path__ + "img/noOrder.7d173c0c.png";